var render = function () {
  var _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "pt-8"
  }, [_c('v-menu', {
    attrs: {
      "value": _vm.contextMenu.item,
      "offset-y": "",
      "absolute": "",
      "position-x": _vm.contextMenu.x,
      "position-y": _vm.contextMenu.y
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    attrs: {
      "link": ""
    },
    on: {
      "click": function click($event) {
        return _vm.openNewTab(_vm.contextMenu.item);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-4 primary--text"
  }, [_vm._v("mdi-open-in-new")]), _vm._v("Open in new tab")], 1)], 1)], 1), _c('v-card', {
    staticClass: "rounded-lg"
  }, [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_c('v-select', {
    staticClass: "mr-4",
    staticStyle: {
      "max-width": "400px"
    },
    attrs: {
      "placeholder": "Schedule",
      "items": _vm.schedules,
      "item-value": "xid",
      "item-text": "title",
      "return-object": "",
      "clearable": "",
      "outlined": "",
      "rounded": "",
      "dense": "",
      "dark": "",
      "hide-details": ""
    },
    model: {
      value: _vm.schedule,
      callback: function callback($$v) {
        _vm.schedule = $$v;
      },
      expression: "schedule"
    }
  }), _c('v-spacer'), _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "small": "",
      "icon": "",
      "dark": "",
      "disabled": !_vm.schedule
    },
    on: {
      "click": function click() {
        _this.page = 1;
        _vm.refreshTasks();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-refresh")])], 1), _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "small": "",
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function click() {
        _this.$refs['scheduleList'].open();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chart-timeline")])], 1), _c('v-btn', {
    staticClass: "mx-1",
    attrs: {
      "small": "",
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.print
    }
  }, [_c('v-icon', [_vm._v("mdi-printer")])], 1)], 1), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "taskTable",
    attrs: {
      "loading": _vm.loading,
      "dense": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "items": _vm.tasks,
      "item-key": "xid",
      "headers": _vm.headers,
      "options": _vm.options,
      "custom-sort": function customSort(items) {
        return items;
      }
    },
    on: {
      "click:row": _vm.clickJob,
      "update:options": function updateOptions($event) {
        _vm.options = $event;
      },
      "contextmenu:row": _vm.rightClickJob
    },
    scopedSlots: _vm._u([{
      key: "item.jobPromised",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [item.jobPromised ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var on = _ref2.on,
                attrs = _ref2.attrs;
              return [_c('span', _vm._g(_vm._b({}, 'span', attrs, false), on), [_vm._v(_vm._s(_vm.moment(item.jobPromised).format('MMM D, Y')))])];
            }
          }], null, true)
        }, [_c('span', {
          staticClass: "font-italic text-caption"
        }, [_vm._v(_vm._s(_vm.moment(item.jobPromised).from()))])]) : _vm._e()];
      }
    }])
  })], 1)], 1), _c('v-row', [_vm.schedule ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.paginate_pages,
      "total-visible": 15
    },
    on: {
      "input": _vm.onPaginate
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _c('ScheduleList', {
    ref: "scheduleList",
    on: {
      "done": _vm.schedulesUpdated
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }